import { gql } from '@apollo/client';

export const GET_PENALTIES_ENUM = gql`
  query GetPenaltiesEnum {
    penaltyEnum {
      penalty
    }
  }
`;
